import React, { useEffect, useState } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import TableFilterBox from "../components/common/TableFilterBox";
import ContentValidation from "../components/common/ContentValidation";
import { IconEnergyLabel } from "../components/Layout/Icons";
import { useDispatch, useSelector } from "react-redux";
import SelectInput from "../components/common/SelectInput";
import TextInputModal from "../components/common/TextInputModal";
import {
  getEnergyLabels,
  getEnergyLabelsOptions,
} from "../redux/Actions/energy_labels_action";
import useModal from "../hooks/useModal";
import EnergyLabelsModalWrapper from "../components/energy_labels/EnergyLabelsModalWrapper";
import Pagination from "../components/Dashboard/items/Pagination";
import TableUi from "../components/Layout/TableUI";
import { handleKeyDown2 } from "../helpers/FunctionsGlobal";
import EnergyLabelColumn from "../components/energy_labels/EnergyLabelColumn";
import { available_countries } from "../helpers/GlobalOptions";
import { flag_icons } from "../helpers/Utils";

const filterInitial = {
  product_code: "",
  energy_class: undefined,
};

export default function EnergyLabelsPage({ match }) {
  const dispatch = useDispatch();
  const { totals, current, loading, data, options } = useSelector(
    (state) => state.custom
  );
  console.log("Main values: ", totals, current, loading, data);
  const [page, setPage] = useState(1);
  const [perCount, setPerPage] = useState(50);
  const [filters, setFilters] = useState(filterInitial);

  const startedPack = () => {
    dispatch(getEnergyLabels(page, perCount, onFilter()));
  };
  useEffect(() => {
    startedPack();
    dispatch(getEnergyLabelsOptions());
  }, []);

  useEffect(() => {
    console.count("FETCH");
    setPage(1);
    startedPack();
  }, [perCount]);

  useEffect(() => {
    console.count("FETCH");
    startedPack();
  }, [page]);

  const { modalOpt, setModalOpt, closeModal } = useModal();

  const onFilter = () => {
    const { product_code, energy_class } = filters;

    let search_string = "";
    if (product_code) {
      search_string += `&q[energy_products_sku_cont]=${product_code}`;
    }
    if (energy_class) {
      search_string += `&q[energy_class_cont]=${energy_class}`;
    }

    return search_string;
  };

  return (
    <Container
      location={{
        locationName: "Energy labels",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data?.length}
          text2="Energy labels"
          iconComponent={
            <IconEnergyLabel
              style={{
                width: 32,
                height: 32,
              }}
            />
          }
          onChangeCountPage={setPerPage}
          countPage={perCount}
        />
      </ContentBlock>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          add={false}
          filter={true}
          onFilter={() => startedPack()}
          clearFilter={() => setFilters(filterInitial)}
          button1={
            <>
              {" "}
              <button
                type="button"
                className="btn btn-sm btn-primary float-left ml-3"
                onClick={() => setModalOpt("create")}
              >
                {"Create new"}
              </button>
            </>
          }
        >
          <div className="pr-1 pl-3">
            <TextInputModal
              text="SKU"
              name="product_code"
              style={{ width: 165 }}
              value={filters.product_code}
              onKeyDown={handleKeyDown2(startedPack)}
              onChange={(e) => {
                const product_code = e.target.value;
                setFilters((prev) => ({ ...prev, product_code }));
              }}
            />
          </div>

          <div className="px-1">
            <SelectInput
              style={{ width: 165 }}
              options={options?.energy_class_image}
              label="Energy Class Image"
              value={filters.energy_class || undefined}
              onChange={(energy_class) => {
                setFilters((prev) => ({
                  ...prev,
                  energy_class,
                }));
              }}
            />
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation
            loader={loading}
            array={current == "EnergyLabels" ? data : []}
          >
            <div className="table-responsive">
              <Pagination
                page={page}
                totals={totals}
                setPagination={setPage}
                pageCount={perCount}
              />
            </div>
            <EnergyLabelsTable
              data={data}
              setModalOpt={setModalOpt}
              options={options}
            />
            <div className="table-responsive">
              <Pagination
                page={page}
                totals={totals}
                setPagination={setPage}
                pageCount={perCount}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>
      {modalOpt?.type && (
        <EnergyLabelsModalWrapper
          modalOpt={modalOpt}
          closeModal={() => closeModal()}
          options={options}
        />
      )}
    </Container>
  );
}

const EnergyLabelsTable = ({ data, setModalOpt, options }) => {
  return (
    <div className="table-responsive">
      <TableUi
        className={"table-striped"}
        ths_expanded={[
          { label: "SKU", style: { paddingBottom: 0, width: 200 } },
          { label: "Energy class", style: { paddingBottom: 0, width: 100 } },
          { label: "Eprel ID", style: { paddingBottom: 0, width: 100 } },
          {
            style: { width: "100px", paddingBottom: 0 },
            label: (
              <div
                className="d-flex flex-column align-items-center"
                style={{
                  borderRight: "1px solid #BFBFBF",
                  borderLeft: "1px solid #BFBFBF",
                  width: 600,
                }}
              >
                <div>Data sheets</div>
                <div className="d-flex my-2">
                  {available_countries.map((d) => (
                    <div
                      key={d.value}
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: 600 / available_countries.length,
                      }}
                    >
                      {flag_icons[d.value]}
                    </div>
                  ))}
                </div>
              </div>
            ),
          },
          { label: "Label image", style: { paddingBottom: 0 } },
          { label: "", style: { paddingBottom: 0 } },
        ]}
      >
        {data.map((label) => {
          return (
            <EnergyLabelColumn
              key={label.id}
              {...label}
              energy_class={
                options?.energy_class_image?.find(
                  (d) => d.value == label.energy_class
                )?.label || label.energy_class
              }
              setModalOpt={setModalOpt}
            />
          );
        })}
      </TableUi>
    </div>
  );
};
